var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CpslIdenticon, CpslSelect, CpslSelectItem, CpslText } from '@usecapsule/react-components';
import { useExternalWallets } from '../../providers/ExternalWalletContext.js';
import styled from 'styled-components';
import { useCapsuleStore, useModalStore } from '../../stores/index.js';
import { truncateAddress, WalletType } from '@usecapsule/web-sdk';
import { useEffect, useRef } from 'react';
import { useDropdownPosition } from '../AuthInput/hooks/useDropdownPosition.js';
import { MOBILE_SIZE } from '../../constants/constants.js';
import { useActiveWallet } from '../../hooks/useActiveWallet.js';
const getValue = (id, type) => {
    return id && type ? `${id}~${type}` : undefined;
};
const WALLET_TYPES = {
    [WalletType.EVM]: 'EVM',
    [WalletType.SOLANA]: 'Solana',
    [WalletType.COSMOS]: 'Cosmos',
};
export const ChainSelect = () => {
    var _a, _b;
    const containerRef = useRef(null);
    const { dropdownMaxHeight, dropdownWidth, mobileAnchor, resize } = useDropdownPosition(containerRef);
    const activeWallet = useActiveWallet();
    const { switchChain, chainId, chains, chainIdSwitchingTo } = useExternalWallets();
    useEffect(() => {
        if (dropdownMaxHeight && chainId) {
            resize();
        }
    }, [chainId, chainIdSwitchingTo, dropdownMaxHeight]);
    const handleChainChange = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
        yield switchChain(chainId);
    });
    if (!activeWallet || !activeWallet.isExternal || activeWallet.type === WalletType.SOLANA) {
        return null;
    }
    const chainIdToUse = chainIdSwitchingTo !== null && chainIdSwitchingTo !== void 0 ? chainIdSwitchingTo : chainId;
    const selectedChainName = (_a = chains.find(c => c.id.toString() === chainIdToUse)) === null || _a === void 0 ? void 0 : _a.name;
    return (_jsx(Container, { children: _jsx(SelectContainer, { ref: containerRef, id: "inputContainer", children: _jsxs(StyledSelect, { selectedValue: (_b = chainIdToUse === null || chainIdToUse === void 0 ? void 0 : chainIdToUse.toString()) !== null && _b !== void 0 ? _b : '', onCpslSelectValueChange: e => {
                    handleChainChange(e.detail);
                }, showFormattedSelectedItem: true, placeholder: "Choose chain...", anchorElId: "inputContainer", dropdownMaxHeight: dropdownMaxHeight, "$width": dropdownWidth, "$top": mobileAnchor + 16 + 1, autoWidth: true, selectedItemVariant: "bodyXS", children: [chainIdToUse && (_jsx(ChainName, { variant: "bodyXS", color: "contrast", slot: "selected-item", children: selectedChainName })), chains === null || chains === void 0 ? void 0 : chains.map(chain => (_jsx(StyledSelectItem, { slot: "items", value: chain.id.toString(), children: _jsx(ChainName, { variant: "bodyXS", color: "contrast", children: chain.name }) }, chain.id)))] }) }) }));
};
function getName(capsule, { type, isExternal, name }, isMenu = false) {
    if (capsule.isMultiWallet) {
        return name !== null && name !== void 0 ? name : `${isExternal ? 'External ' : ''}${WALLET_TYPES[type]}${isMenu || isExternal ? ' Wallet' : ''}`;
    }
    return name !== null && name !== void 0 ? name : 'My Wallet';
}
export const AccountSelect = () => {
    const capsule = useCapsuleStore(state => state.capsule);
    const containerRef = useRef(null);
    const { dropdownMaxHeight, dropdownWidth, mobileAnchor, resize } = useDropdownPosition(containerRef);
    const setActiveWallet = useModalStore(state => state.setActiveWallet);
    const activeWallet = useActiveWallet();
    const ActiveWalletNode = activeWallet ? (_jsxs(FlexRow, { slot: "selected-item", children: [_jsx(CpslIdenticon, { variant: "avatar", size: "14px", hash: capsule.getIdenticonHash(activeWallet.id, activeWallet.type) }), _jsx(WalletName, { variant: "bodyXS", color: "contrast", children: getName(capsule, activeWallet) }), _jsx(CpslText, { variant: "bodyXS", color: "secondary", children: capsule.getDisplayAddress(activeWallet.id, { truncate: true, addressType: activeWallet.type }) })] })) : null;
    useEffect(() => {
        if (dropdownMaxHeight && (activeWallet === null || activeWallet === void 0 ? void 0 : activeWallet.address)) {
            resize();
        }
    }, [activeWallet, capsule.availableWallets, dropdownMaxHeight]);
    return (_jsx(Container, { children: _jsx(SelectContainer, { ref: containerRef, id: "addressInputContainer", children: capsule.availableWallets.length > 1 ? (_jsxs(StyledSelect, { selectedValue: getValue(activeWallet === null || activeWallet === void 0 ? void 0 : activeWallet.id, activeWallet === null || activeWallet === void 0 ? void 0 : activeWallet.type), onCpslSelectValueChange: e => {
                    const [id, type] = e.detail.split('~');
                    setActiveWallet([id, type]);
                }, showFormattedSelectedItem: true, placeholder: "Choose wallet...", anchorElId: "addressInputContainer", dropdownMaxHeight: dropdownMaxHeight, "$width": dropdownWidth, "$top": mobileAnchor + 16 + 1, autoWidth: true, selectedItemVariant: "bodyXS", children: [activeWallet && ActiveWalletNode, capsule.availableWallets.map(({ address, name: _name, id, type, isExternal }) => {
                        const key = getValue(id, type);
                        const name = _name !== null && _name !== void 0 ? _name : getName(capsule, { type, isExternal }, true);
                        return (_jsx(StyledSelectItem, { slot: "items", value: key, children: _jsxs(FlexRow, { children: [_jsx(CpslIdenticon, { size: "40px", hash: capsule.getIdenticonHash(id, type) }), _jsxs(FlexCol, { children: [name && (_jsx(CpslText, { variant: "bodyS", color: "contrast", children: name })), _jsx(CpslText, { variant: "bodyXS", color: "secondary", children: truncateAddress(address, type, { prefix: capsule.cosmosPrefix }) })] })] }) }, key));
                    })] })) : (ActiveWalletNode) }) }));
};
const Container = styled.div `
  flex: 0;
  width: 100%;
  display: flex;
  justify-content: center;
`;
const FlexRow = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
const FlexCol = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const WalletName = styled(CpslText) `
  white-space: nowrap;
`;
const SelectContainer = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 1000px;
  background-color: var(--cpsl-color-background-8);
  padding: 8px;
`;
const ChainName = styled(CpslText) `
  max-width: 150px;
  text-transform: capitalize;

  &::part(text-element) {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
const StyledSelect = styled(CpslSelect) `
  --container-height: auto;
  --container-border-width: 0px;
  --container-padding-end: 0px;
  --container-padding-start: 0px;
  --container-background-color: transparent;
  --container-box-shadow: none;
  --container-gap: 2px;
  --icon-width: 16px;
  --icon-height: 16px;

  &::part(selected-text) {
    white-space: nowrap;
  }

  &::part(dropdown) {
    min-width: ${({ $width }) => `${$width - 2}px`};
  }

  &::part(popover) {
    /* Have to adjust the top of the popover here since we're using a transform on the modal which causes fixed position items to not be relative to the viewport */
    @media (max-width: ${MOBILE_SIZE}px) {
      top: ${({ $top }) => ($top ? `${$top}px` : '0px')};
      bottom: 16px;
    }
    cpsl-auth-modal.force-mobile-media & {
      top: ${({ $top }) => ($top ? `${$top}px` : '0px')};
      bottom: 16px;
    }
  }

  &::part(icon) {
    --icon-color: var(--cpsl-color-contrast);
  }
`;
const StyledSelectItem = styled(CpslSelectItem) `
  --outer-container-padding-start: 4px;
  --outer-container-padding-end: 4px;
  --outer-container-padding-top: 4px;
  --outer-container-padding-bottom: 4px;
`;
